import type { CatalogueUsage, CatalogueUsageSource } from '../types/brand.types';

const USAGE_LABELS: Record<CatalogueUsageSource, [singular: string, plural: string]> = {
  orders: ['order', 'orders'],
  carts: ['cart item', 'cart items'],
  paymentAttempts: ['payment attempt', 'payment attempts'],
  reviews: ['review', 'reviews'],
  ratings: ['rating', 'ratings'],
  favourites: ['customer favourite', 'customer favourites'],
  partnerProfits: ['partner profit setting', 'partner profit settings'],
  shares: ['share agreement', 'share agreements'],
  sliders: ['storefront slider banner', 'storefront slider banners'],
};

/** "2 orders, 1 review" — what still points at a denomination and blocks deleting it. */
export function describeUsage(usage: CatalogueUsage[]): string {
  return usage
    .map(({ source, count }) => {
      const [one, many] = USAGE_LABELS[source] ?? [source, source];
      return `${count} ${count === 1 ? one : many}`;
    })
    .join(', ');
}
